import { Text, Stack, SimpleGrid } from "@mantine/core";
import { OptimizedImage as Image } from "@/components/helpers/optimizedImage/optimizedImage";
import variables from "../../../styles/variables.module.scss";
import parse from "html-react-parser";
import { useWindowSize } from "@/hooks";

export function Gallery5({ options }) {
  const isMobile = useWindowSize().width < 768;
  const isTablet = useWindowSize().width < 1000;
  const componentStyles = options?.styles;

  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: isMobile ? 0 : 32,
    padding: 48,
    paddingLeft: isMobile ? 24 : 48,
    paddingRight: isMobile ? 24 : 48,
    paddingTop: options?.fullWidth ? 0 : 48,
    paddingBottom: options?.fullWidth ? 0 : 48,
  };
  const titleStyle = {
    fontSize: 48,
    fontWeight: "bold",
    textAlign: "center",
    color: variables.primaryColor,
  };

  let descJSX = options?.description && (
    <Text
      fz={options.descFontSize || 16}
      fw={400}
      ta={options?.descriptionAlign ?? "center"}
    >
      {parse(options.description)}
    </Text>
  );
  let imgJSX = (
    <Image
      styles={
        options.fullWidth
          ? {
            root: {
              top: "-24px",
              minWidth: "100vw",
              marginLeft: "calc(50% - 50vw)",
              marginRight: "calc(50% - 50vw)",
            },
          }
          : undefined
      }
      src={options.src}
      alt=""
      fit={options.fit}
      radius={options?.fullWidth ? 0 : (options.radius ?? 8)}
    />
  );

  return (
    <div
      style={{
        ...wrapperStyle,
        ...(componentStyles || {}),
      }}
    >
      {options?.title && (
        <Text
          style={{
            ...titleStyle,
            ...(componentStyles?.header || {}),
          }}
        >
          {options.title}
        </Text>
      )}
      {options?.horizontal ? (
        <SimpleGrid cols={isTablet ? 1 : 2} spacing={36}>
          {options?.imgLeft ? (
            <>
              {imgJSX}
              {descJSX}
            </>
          ) : (
            <>
              {descJSX}
              {imgJSX}
            </>
          )}
        </SimpleGrid>
      ) : (
        <Stack spacing={36}>
          {descJSX}
          {imgJSX}
        </Stack>
      )}
    </div>
    // </Stack>
  );
}
